const GameModes = Object.freeze({
    Emerald: "emerald",
    Sanctuary: "sanctuary",
    Obsidian: "obsidian",
    Stronghold: "stronghold",
    Skirmish: "skirmish",
    JadeEdict: "jade-edict",
});

module.exports = GameModes;



// WEBPACK FOOTER //
// ./client/GameModes.js